<template>
  <!-- <div class="grid gap-4"> -->
    <!-- Cards -->
     
        
    <!-- <div class="grid"> -->
        <!-- Total Orders -->
        <!-- <div class="col">
            <Card class="h-full">
            <template #title>
                <div class="flex align-items-center gap-2 mb-8">
                <i class="pi pi-list text-blue-500 text-lg"></i>
                <span>Total Orders</span>
                </div>
            </template>
            <template #content>
                <div class="text-3xl font-bold mt-8">68 Orders</div>
                <div class="text-sm text-500">₹45.2 Cr</div>
            </template>
            </Card>
        </div> -->

        <!-- Completed Orders -->
        <!-- <div class="col">
            <Card class="h-full">
            <template #title>
                <div class="flex align-items-center gap-2 mb-8">
                <i class="pi pi-check-circle text-green-500 text-lg"></i>
                <span>Completed Orders</span>
                </div>
            </template>
            <template #content>
                <div class="text-3xl font-bold mt-8">45 Orders</div>
                <div class="text-sm text-500">₹28 Cr</div>
            </template>
            </Card>
        </div> -->
        

        <!-- Billed Orders -->
        <!-- <div class="col">
            <Card class="h-full">
            <template #title>
                <div class="flex align-items-center gap-2 mb-8">
                <i class="pi pi-credit-card text-cyan-500 text-lg"></i>
                <span>Billed Orders</span>
                </div>
            </template>
            <template #content>
                <div class="text-3xl font-bold mt-8">32 Orders</div>
                <div class="text-sm text-500">₹22 Cr</div>
            </template>
            </Card>
        </div> -->

        
        <!-- Available for Billing -->
        <!-- <div class="col">
            <Card class="h-full">
            <template #title>
                <div class="flex align-items-center gap-2 mb-8">
                <i class="pi pi-credit-card text-cyan-500 text-lg"></i>
                <span>Available for Billing</span>
                </div>
            </template>
            <template #content>
                    <div class="text-3xl font-bold mt-8">32 Orders</div>
                    <div class="text-sm text-500">₹22 Cr</div>
                     <ProgressBar :value="80" class="mt-2 h-2"></ProgressBar>
            </template>
            </Card>
        </div> -->


        <!-- Donut Chart -->
        <!-- <div class="col ">
            
            <Card class="h-full ">
                <template #title>
                <span>Order Status Analytics</span>
                </template>
                <template #content>
                <Chart
                    type="doughnut"
                    :data="chartData"
                    :options="chartOptions"
                    style="width:100%; max-height:220px;"
                />
                </template>
            </Card>

        </div> -->
    <!-- </div> -->

    <!-- <div class="col-12 md:col-12 grid"> -->
        <!-- Pending Orders -->
        <!-- <div class="col-12 md:col-4">
            <Card class="h-full">
            <template #title>
                <div class="flex align-items-center gap-2">
                <i class="pi pi-clock text-orange-400 text-lg"></i>
                <span>Pending Orders</span>
                </div>
            </template>
            <template #content>
                <div class="text-3xl font-bold">23 Orders</div>
                <div class="text-sm text-500">₹17.2 Cr</div>
            </template>
            </Card>
        </div> -->

        <!-- Available for Billing -->
        <!-- <div class="col-12 md:col-4">
            <Card class="h-full">
            <template #title>
                <div class="flex align-items-center gap-2 ">
                <i class="pi pi-credit-card text-cyan-500 text-lg"></i>
                <span>Available for Billing</span>
                </div>
            </template>
            <template #content>
                <div >
                    <div class="text-xl font-bold">₹10 Cr</div>
                    <div class="text-sm text-500">₹12.5 Cr Total Due</div>
                    <ProgressBar :value="80" class="mt-2 h-2"></ProgressBar>

                </div>
            </template>
            </Card>
        </div> -->
    <!-- </div> -->
    

  <!-- </div> -->

  <!-- <div class="grid nested-grid">
    <div class="col-7">
        <div class="grid">
            <div class="col-6">
                <div class=" ">
                    <Card class="h-full">
                    <template #title>
                        <div class="flex align-items-center gap-2">
                        <i class="pi pi-list text-blue-500 text-lg"></i>
                        <span>Total Orders</span>
                        </div>
                    </template>
                    <template #content>
                        <div class="mt-5">
                            <div class="text-2xl font-bold">68 Orders</div>
                            <div class="text-sm text-500 mb-3">₹45.2 Cr</div>
                        </div>
                    </template>
                    </Card>
                </div>
            </div>
            <div class="col-6">
                <div class=" ">
                    <Card class="h-full">
                    <template #title>
                        <div class="flex align-items-center gap-2">
                        <i class="pi pi-check-circle text-green-500 text-lg"></i>
                        <span>Completed Orders</span>
                        </div>
                    </template>
                    <template #content>
                        <div class="mt-3">
                            <div class="text-2xl font-bold">45 Orders</div>
                            <div class="text-sm text-500">₹28 Cr Total Due</div>
                            <ProgressBar :value="70" class="mt-1 h-2 mb-2"></ProgressBar>
                        </div>
                    </template>
                    </Card>
                </div>
            </div>
            <div class="col-6">
                <div class=" ">
                    <Card class="h-full">
                    <template #title>
                        <div class="flex align-items-center gap-2">
                        <i class="pi pi-clock text-orange-400 text-lg"></i>
                        <span>Pending Orders</span>
                        </div>
                    </template>
                    <template #content>
                        <div class="mt-3">

                            <div class="text-2xl font-bold">23 Orders</div>
                            <div class="text-sm text-500">₹17.2 Cr Total Due</div>
                            <ProgressBar :value="30" class="mt-1 h-2 mb-2"></ProgressBar>
                        </div>
                    </template>
                    </Card>
                </div>
            </div>
            <div class="col-6">
                <div class=" ">
                    <Card class="h-full">
                        <template #title>
                            <div class="flex align-items-center gap-2 ">
                            <i class="pi pi-credit-card text-cyan-500 text-lg"></i>
                            <span>Available for Billing</span>
                            </div>
                        </template>
                        <template #content>
                            <div class="mt-3">
                                <div class="text-2xl font-bold">₹10 Cr</div>
                                <div class="text-sm text-500">₹12.5 Cr Total Due</div>
                                <ProgressBar :value="80" class="mt-1 h-2 mb-2"></ProgressBar>

                            </div>
                        </template>
                    </Card>
                </div>
            </div>
        </div>
    </div>
    <div class="col-5">        
        <Card class="text-center">                
            <template #content>
                <div class="flex justify-content-around flex-wrap mb-4">
                    <div class="flex align-items-center justify-content-center ">
                        <div class="field">
                            <label class="text-xl font-bold mb-3">Completion Statistics</label>
                            <Chart
                                type="doughnut"
                                :data="chartData"
                                :options="chartOptions"
                                style="width:100%; max-height:220px;"
                            />
                        </div>
                    </div>
                    <div class="flex align-items-center justify-content-center ">
                        <div class="field">
                            <label class="text-xl font-bold mb-3">Bill Statistics</label>
                            <Chart
                                type="doughnut"
                                :data="chartData"
                                :options="chartOptions"
                                style="width:100%; max-height:220px;"
                            />
                        </div>
                    </div>
                </div>
            </template>
        </Card>       
    </div>
  </div> -->



<div class="grid mt-1">
    <div class="col-12">
        <div >
            <Card class="h-full">
                <!-- <template #title>
                    <div class="flex align-items-center gap-2">
                    <i class="pi pi-list text-blue-500 text-lg"></i>
                    <span>Total Orders</span>
                    </div>
                </template> -->
                <template #content>
                    <!-- <div class="mt-5">
                        <div v-if="orderCount" class="text-2xl font-bold">{{ orderCount }} Orders</div>
                        <Skeleton v-if="!orderCount" width="6rem" height="2rem"></Skeleton>
                        <div v-if="orderCount > 0" class="text-sm text-500 mb-3 font-medium" >{{ formatCurrency(orderValue) }}</div>
                    </div> -->

                    <div class="grid">
                        <div class="col">

                            <div class=" ">
                                <i class="pi pi-list text-blue-500 text-lg mr-1"></i>
                                <span class="text-xl font-semibold">Total Orders</span>
                            </div>

                            <div v-if="orderCount" class="text-2xl font-bold mt-8">{{ orderCount }} Orders</div>
                            <Skeleton v-if="!orderCount" width="6rem" height="2rem"></Skeleton>
                            <div v-if="orderCount > 0" class="text-sm text-500 mb-3 font-medium" >{{ formatCurrency(orderValue) }}</div>
                        </div>
                        <div class="col flex justify-content-end">
                            <div >
                                <Chart
                                    type="doughnut"
                                    :data="chartDataOrderCompletion"
                                    :options="chartOptions"
                                    style="width:100%; max-height:140px;"
                                />
                            </div>
                        </div>
                    </div>

                </template>
            </Card>
        </div>
    </div>
    <div class="col-12">
        <div >
            <Card class="h-full">
                <template #title>
                    <div class="flex align-items-center gap-2">
                    <i class="pi pi-check-circle text-green-500 text-lg"></i>
                    <span>Completed</span>
                    </div>
                    
                </template>
                <template #content>
                    <div class="mt-3">
                        <div v-if="completedOrdersCount" class="text-2xl font-bold">{{ completedOrdersCount }} Orders</div>
                        <div class="text-sm text-500">{{ formatCurrency(completedOrderValue) }}</div>
                        
                        <!-- <div v-if="completedOrdersCount > 0" class="text-sm text-500 mb-3 font-medium" >{{ formatCurrency(completedOrderValue) }}</div> -->


                        <Skeleton v-if="!completedOrdersCount" width="6rem" height="2rem"></Skeleton>

                        <ProgressBar :value="completionPerc" class="mt-1 h-2 mb-2"></ProgressBar>
                        <div>
                            <label class="text-sm text-500">
                                Completion % from total no. of POs received
                            </label>
                        </div>
                    </div>
                </template>
            </Card>
        </div>
    </div>
    <div class="col-12">
        <div >
            <Card class="h-full">
                <template #title>
                    <div class="flex align-items-center gap-2">
                    <i class="pi pi-clock text-orange-400 text-lg"></i>
                    <span>Pending</span>
                    </div>
                </template>
                <template #content>
                    <div class="mt-3">

                        <Skeleton v-if="!pendingOrderCount" width="6rem" height="2rem" class="mb-2"></Skeleton>
                        <div v-if="pendingOrderCount" class="text-2xl font-bold">{{ pendingOrderCount }} Orders</div>
                        <div v-if="pendingOrderCount" class="text-sm text-500 my-1">Total Order Value: {{ formatCurrency(pendingOrderValue) }}</div>
                        
                        <!-- <ProgressBar :value="Math.trunc(((orderCount-completedOrdersCount) / orderCount) * 100)" class="mt-1 h-2 mb-2"></ProgressBar> -->
                         <MeterGroup v-if="pendingOrderCount" :value="pendingItemsStatistics"></MeterGroup>
                         <Skeleton v-if="!pendingOrderCount" width="38rem" height="2rem"></Skeleton>
                    </div>
                </template>
            </Card>
        </div>
    </div>
    <div class="col-12">
        <div >
            <Card class="h-full">
                <template #title>
                    <!-- <div class="flex align-items-center gap-2 ">
                        <i class="pi pi-credit-card text-cyan-500 text-lg"></i>
                        <span>Available for Billing</span>
                    </div> -->
                </template>
                <template #content>
                    <div class="grid">
                        <div class="col">
                            <div class=" ">
                                <i class="pi pi-credit-card text-cyan-500 text-lg mr-1"></i>
                                <span class="text-xl font-semibold">Available for Billing</span>
                            </div>
                            <div class="mt-8">
                                <div class="text-2xl font-bold">{{ formatCurrency(possibleBillingValue) }}</div>
                                <div class="text-sm text-500">Total due: {{ formatCurrency(pendingValue) }}</div>

                                <!-- <ProgressBar :value="80" class="mt-1 h-2 mb-2"></ProgressBar> -->
                            </div>
                            <div>
                                <div class="text-sm text-500">
                                    (Not delivered + Challan Not Recd)
                                </div>
                            </div>
                        </div>
                        <div class="col flex justify-content-end">
                            <div >
                                <Chart
                                    type="doughnut"
                                    :data="chartDataBilling"
                                    :options="chartOptions"
                                    style="width:100%; max-height:140px;"
                                />
                            </div>
                        </div>
                    </div>
                    <!-- <div class="mt-3">
                        <div class="text-2xl font-bold">{{ formatCurrency(possibleBillingValue) }}</div>
                        <div class="text-sm text-500">Total due {{ formatCurrency(pendingValue) }}</div>
                        <ProgressBar :value="80" class="mt-1 h-2 mb-2"></ProgressBar>

                    </div> -->
                </template>
            </Card>
        </div>
    </div>
    
</div>



</template>

<script>
import Card from "primevue/card";
import ProgressBar from "primevue/progressbar";
import Chart from "primevue/chart";
import { availableForBilling, completedOrders, pendingOrders, totalDeptOrder } from "@/services/api/v2/apis";
import Skeleton from "primevue/skeleton";
import MeterGroup from "primevue/metergroup";

export default {
    name: "OrderDashboard",
    
    components: {
        Card,
        ProgressBar,
        Chart,
        Skeleton,
        MeterGroup,
  },

  data() {
    return {
      chartDataBilling: {
        datasets: [
          {
            backgroundColor: ["#4FBCFF", "#FF0000"],
            hoverBackgroundColor: ["#2563EB", "#FF7373"],
          },
        ],
      },
      chartDataOrderCompletion: {
        datasets: [
          {
            backgroundColor: ["#22C55E", "#FF0000"],
            hoverBackgroundColor: ["#16A34A", "#FF7373"],
          },
        ],
      },
      chartOptions: {
        cutout: "70%",
        plugins: {
          legend: {
            display: false,
          },
        },
      },
      orderCount: null,
      orderValue:0,
      completedOrdersCount:null,
      completionPerc:0,
      completedOrderValue:0,
      pendingOrderCount:null,
      pendingOrderValue:0,
      pendingItemsStatistics:[],
      possibleBillingValue:0,
      pendingValue:0,
    };
  },
  methods:{
    async fetchAnalyticsData(){
        const response = await totalDeptOrder();
        this.orderCount = response.data.totalOrders;
        this.orderValue = response.data.orderValue;

        const response2 = await completedOrders();
        this.completedOrdersCount = response2.data.completedOrders;
        this.completedOrderValue = response2.data.orderValue; 
        
        this.completionPerc = Math.trunc((this.completedOrdersCount / this.orderCount) * 100);
        
        const res3 = await pendingOrders();
        this.pendingOrderCount = res3.data.pendingOrders;
        this.pendingOrderValue = res3.data.totalOrderValue;
        const totalValue = res3.data.pendingOrderValue + res3.data.completedOrderValue;
        // const totalValue = res3.data.totalOrderValue;
        
        const res4 = await availableForBilling();
        this.possibleBillingValue = res4.data.availableForBilling;
        this.pendingValue = res4.data.totalPendingValue;
        this.updateBillingChartData(this.possibleBillingValue, this.pendingValue, 'Available For Billing', 'Total Pending');

        this.updateOrderCompletionChart(response.data.completion, (100 - response.data.completion), 'Completed (%)', 'Pending (%)');
        
        
        this.pendingItemsStatistics = [];
        this.pendingItemsStatistics.push(
            {
                label: 'Pending',
                color: '#FF9E30',
                value: parseFloat(((res3.data.pendingOrderValue / totalValue) * 100).toFixed(2)),
            }
        );
        this.pendingItemsStatistics.push({
                label: 'Completed',
                color: '#2BE324',
                value: parseFloat(((res3.data.completedOrderValue / totalValue) * 100).toFixed(2)),
            })

    },
    updateBillingChartData(data1, data2, label1, label2){
        this.chartDataBilling.datasets[0].data = [data1, data2];
        this.chartDataBilling.labels = [`${label1}`, `${label2}`];
    },
    updateOrderCompletionChart(data1, data2, label1, label2){
        this.chartDataOrderCompletion.datasets[0].data = [data1, data2];
        this.chartDataOrderCompletion.labels = [`${label1}`, `${label2}`];
    },
    formatCurrency(value) {
        return value.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
    },
  },
  mounted(){
    this.fetchAnalyticsData();
  }
};
</script>

<style scoped>
.text-500 {
  color: #6b7280;
}
</style>
